import {
  CUSTOMERS_URL,
  CUSTOMER_URL,
  SEARCH_CUSTOMERS_URL,
  CUSTOMER_MOMENTS_URL,
  CUSTOMER_NOTIFY_URL,
  CUSTOMER_MOMENTS_DELETE
} from 'app/utils/Constants';

import {
  get,
  post,
  put,
  patch
} from 'app/services/ApiService';

import {
  OPERATOR_KEY,
  OR_OPERATOR,
  AND_OPERATOR
} from 'app/utils/Constants';

import {
  TEXT,
  EQUALS,
  CONTAINS
} from 'app/hooks/useFilter';

export const searchCustomers = async (page, perPage, filterValue, jobId) => {
  let filterModel = {
    [OPERATOR_KEY]: [{ value: OR_OPERATOR }]
  }

  if (filterValue) {
    let filter = {
      filterClass: TEXT,
      filterType: CONTAINS,
      value: filterValue,
      operator: OR_OPERATOR
    }

    filterModel = {
      ...filterModel,
      name: [filter],
      email: [filter],
      phone: [filter],
      access_code: [filter]
    }
  }

  if (jobId) {
    filterModel.job_id = [{
      filterClass: TEXT,
      filterType: EQUALS,
      value: jobId.toString(),
      operator: AND_OPERATOR
    }];
  }

  let params = {
    page,
    per_page: perPage,
    filter_model: filterModel,
    sort_model: []
  }

  let resp = await getCustomers(params);

  return resp.records;
}

export const getCustomer = async id => {
  let params = {
    page: 1,
    per_page: 1,
    filter_model: {
      id: [{
      filterClass: TEXT,
      filterType: EQUALS,
      value: id.toString()
      }]
    },
    sort_model: []
  }

  let resp = await getCustomers(params);
  return resp.records[0];
}

export const getCustomers = async params => {
  return await post(SEARCH_CUSTOMERS_URL(), params);
}

export const createCustomer = async params => {
  return await post(CUSTOMERS_URL(), params);
}

export const updateCustomer = async (id, params) => {
  return await put(CUSTOMER_URL(id), params);
}

export const destroyCustomers = async ids => {
  let params = { ids };
  return await patch(CUSTOMERS_URL(), params);
}

export const getCustomerMoments = async (id, page, perPage) => {
  return await get(CUSTOMER_MOMENTS_URL(id, page, perPage));
}

export const notifyCustomer = async params => {
  return await put(CUSTOMER_NOTIFY_URL(), params);
};

export const deleteCustomerMoments = async (id, params) => {
  return await post(CUSTOMER_MOMENTS_DELETE(id), params);
};
